import {
  AclAssetChildResourceType,
  AclAssetModuleResourceType,
  AclAssetResourceType,
  AclResourceTypeToChildResourceType,
} from '@y42/acl/models';
import { Y42FeatureType } from '@y42/json-schema';

export const Y42FeatureToAclAssetModuleResourceType: Record<Y42FeatureType, AclAssetModuleResourceType | null> = {
  [Y42FeatureType.Integration]: AclAssetModuleResourceType.Integrations,
  [Y42FeatureType.UiModel]: AclAssetModuleResourceType.Models,
  [Y42FeatureType.SqlModel]: AclAssetModuleResourceType.Models,
  [Y42FeatureType.Orchestration]: AclAssetModuleResourceType.Orchestrations,
  [Y42FeatureType.VisualizationDashboard]: AclAssetModuleResourceType.Visualizations,
  [Y42FeatureType.VisualizationWidget]: AclAssetModuleResourceType.Visualizations,
  [Y42FeatureType.VisualizationFilter]: AclAssetModuleResourceType.Visualizations,
  [Y42FeatureType.VisualizationTheme]: AclAssetModuleResourceType.Visualizations,
  [Y42FeatureType.Export]: AclAssetModuleResourceType.DataExports,
  [Y42FeatureType.StatusAlert]: AclAssetModuleResourceType.Alerts,
  [Y42FeatureType.Lineage]: AclAssetModuleResourceType.Lineage,
  [Y42FeatureType.Catalog]: null,
};

export const Y42FeatureToAclAssetResourceType: Record<Y42FeatureType, AclAssetResourceType | null> = {
  [Y42FeatureType.Integration]: AclAssetResourceType.Integration,
  [Y42FeatureType.UiModel]: AclAssetResourceType.UIModel,
  [Y42FeatureType.SqlModel]: AclAssetResourceType.SQLModel,
  [Y42FeatureType.Orchestration]: AclAssetResourceType.Orchestration,
  [Y42FeatureType.VisualizationDashboard]: AclAssetResourceType.VisualizationDashboard,
  [Y42FeatureType.VisualizationWidget]: AclAssetResourceType.VisualizationDashboardWidget,
  [Y42FeatureType.VisualizationFilter]: null,
  [Y42FeatureType.VisualizationTheme]: null,
  [Y42FeatureType.Export]: AclAssetResourceType.Export,
  [Y42FeatureType.StatusAlert]: AclAssetResourceType.StatusAlert,
  [Y42FeatureType.Lineage]: AclAssetResourceType.LineageSnapshot,
  [Y42FeatureType.Catalog]: null,
};

export const Y42FeatureToAclAssetChildResourceType: Record<Y42FeatureType, AclAssetChildResourceType | null> = {
  [Y42FeatureType.Integration]: AclResourceTypeToChildResourceType[AclAssetResourceType.Integration],
  [Y42FeatureType.UiModel]: AclResourceTypeToChildResourceType[AclAssetResourceType.UIModel],
  [Y42FeatureType.SqlModel]: AclResourceTypeToChildResourceType[AclAssetResourceType.SQLModel],
  [Y42FeatureType.Orchestration]: AclResourceTypeToChildResourceType[AclAssetResourceType.Orchestration],
  [Y42FeatureType.VisualizationDashboard]:
    AclResourceTypeToChildResourceType[AclAssetResourceType.VisualizationDashboard],
  [Y42FeatureType.VisualizationWidget]:
    AclResourceTypeToChildResourceType[AclAssetResourceType.VisualizationDashboardWidget],
  [Y42FeatureType.VisualizationFilter]: null,
  [Y42FeatureType.VisualizationTheme]: null,
  [Y42FeatureType.Export]: AclResourceTypeToChildResourceType[AclAssetResourceType.Export],
  [Y42FeatureType.StatusAlert]: AclResourceTypeToChildResourceType[AclAssetResourceType.StatusAlert],
  [Y42FeatureType.Lineage]: AclResourceTypeToChildResourceType[AclAssetResourceType.LineageSnapshot],
  [Y42FeatureType.Catalog]: null,
};
